import {RentalOrderResponseBody} from '@dms/api/rental';

import {Nullish} from 'shared/web';

type RentalOrderState = RentalOrderResponseBody['state'];

/**
 * States in which the API rejects a vehicle or planned period change.
 * Mirrors the backend guards DMS-CR-RO-0026 (canceled) and DMS-CR-RO-0028 (rented).
 */
const STATES_BLOCKING_VEHICLE_CHANGE = [
  'rented',
  'canceled',
] as const satisfies readonly RentalOrderState[];

export type VehicleChangeBlockingState = (typeof STATES_BLOCKING_VEHICLE_CHANGE)[number];

export function isVehicleChangeBlocked(
  state: RentalOrderState | Nullish
): state is VehicleChangeBlockingState {
  return STATES_BLOCKING_VEHICLE_CHANGE.some((blockingState) => blockingState === state);
}
